// import Vue from 'vue'
// import axios from 'axios'
// import VueAxios from 'vue-axios'
// Vue.use(axios)
// Vue.use(VueAxios)
import axios from '@/plugins/axios'

export default {
  install(Vue) {
    Vue.prototype.$bookApiService = {
      book_api_url: `${process.env.VUE_APP_DHARMA_API_URL}/books`,

      /**
       * 查詢
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async query(param = '') {
        const url = `${this.book_api_url}`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 根據語言查詢
       * @param {string} language - 語言
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryByLanguage(language, additional = '') {
        const url = `${this.book_api_url}/${language}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 透過關鍵字進行模糊查詢
       * @param {string} keyword - 查詢關鍵字
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryByKeyword(keyword, additional = '') {
        const url = `${this.book_api_url}?filter[of_keyword]=${keyword}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 透過多個關鍵字進行模糊查詢（AND 邏輯）
       * @param {string} keywords - 以逗號分隔的多個關鍵字（例如 '金剛經,註解'）
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async queryByKeywords(keywords, additional = '') {
        const url = `${this.book_api_url}?filter[of_keywords][0]=${keywords}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得最新新增的書籍
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getRecentlyAdded(additional = '') {
        const url = `${this.book_api_url}/recently-added`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)
        return response.data
      },

      /**
       * 取得資料筆數
       * @param {string} param - API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getCount(param = '') {
        const url = `${this.book_api_url}/count`
        const params = param ? `?${param}` : ''
        const response = await axios.get(`${url}${params}`)
        return response.data
      },

      /**
       * 透過編碼取得書籍
       * @param {string} code - 編碼
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getByCode(code, additional = '') {
        const url = `${this.book_api_url}?filter[code]=${code}`
        const additional_params = additional ? `&${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && response.data.data.length > 0
          ? { data: response.data.data[0] }
          : null
      },

      /**
       * 透過 ID 取得書籍
       * @param {string} id - ID
       * @param {string} additional - 額外的 API 查詢參數
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getById(id, additional = '') {
        const url = `${this.book_api_url}/${id}`
        const additional_params = additional ? `?${additional}` : ''
        const response = await axios.get(`${url}${additional_params}`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data
          : null
      },

      /**
       * 取得書籍的電子檔案
       * @param {Object} book - 書籍物件
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getEfiles(book) {
        const response = await axios.get(`${this.book_api_url}/${book.id}/efiles?include=attached&order=name,asc`);
        const data = response.data.data;

        return data.reduce((group, item) => {
          const { attached: { chinese_name } } = item;

          if (!group[chinese_name]) {
            group[chinese_name] = [];
          }
          group[chinese_name].push(item);

          return group;
        }, {});
      },

      /**
       * 取得書籍的封面
       * @param {Object} book - 書籍物件
       * @param {*} default_value - 預設值
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getCover(book, default_value = null) {
        const response = await axios.get(`${this.book_api_url}/${book.id}/cover`)
        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data.data
          : default_value
      },

      /**
       * 取得書籍的前封面
       * @param {Object} book - 書籍物件
       * @param {*} default_value - 預設值
       * @returns {Promise<Object>} API 回傳的資料結構
       */
      async getFrontCover(book, default_value = null) {
        const response = await axios.get(`${this.book_api_url}/${book.id}/front-cover`)

        return response.data.data && Object.keys(response.data.data).length > 0
          ? response.data.data
          : default_value
      }
    }
  }
}
